import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface TypeInventoryItem {
  code: string;
  name: string;
  type: string;
  voucherInfo?: string | null;
}

export interface TypeInventoryInfoResponse {
  success: boolean;
  message: string;
  inventoryList: TypeInventoryItem[];
  totalItems: number;
  pageNumber: number;
  itemsPerPage: number;
  exceptionMessage: string;
}

@Injectable({
  providedIn: 'root'
})
export class DfontanaService {
  private baseUrl = environment.apiUrl + '/dfontana';

  constructor(private http: HttpClient) {}

  /**
   * Obtener tipos de movimientos de inventario desde Dfontana
   */
  getTypeInventoryInfo(code?: string, itemsPerPage: number = 100, pageNumber: number = 1): Observable<TypeInventoryInfoResponse> {
    let params = new HttpParams()
      .set('itemsPerPage', itemsPerPage.toString())
      .set('pageNumber', pageNumber.toString());

    if (code) {
      params = params.set('code', code);
    }

    return this.http.get<TypeInventoryInfoResponse>(`${this.baseUrl}/inventory/type-info`, { params });
  }

  /**
   * Obtener todos los tipos de inventario (sin paginación)
   */
  getAllTypeInventoryInfo(): Observable<TypeInventoryInfoResponse> {
    return this.getTypeInventoryInfo(undefined, 100, 1);
  }

  /**
   * Registrar movimiento de inventario (descuento de stock)
   */
  insertInventoryMovement(data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/inventory/insert-movement`, data);
  }

  /**
   * Registrar movimiento de inventario sin centralización (ajustes, traspasos)
   */
  insertInventoryMovementSkipCentralization(data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/inventory/insert-movement-skip-centralization`, data);
  }
}
